
const CHANGE_PRICE_LIST_API = {
    // Item Details From QR_Code
    CHANGE_PRICE_LIST_CREATE: "api/master/saveChangePrice",
    CHANGE_PRICE_LIST: "api/master/getChangePriceList",
};

export default CHANGE_PRICE_LIST_API;